import { Link } from 'gatsby';
import styled, { css } from '../theme/styled-components';

const Base = css<{ bold?: boolean }>`
  font-weight: ${props =>
    props.bold ? props.theme.typography.link.fontWeight : null};
`;

const Primary = css`
  color: ${props => props.theme.colors.primary.base};

  font-size: ${props => props.theme.typography.body.fontSize};
  &:hover,
  &:focus {
    color: ${props => props.theme.colors.primary.hover};
    text-decoration: none;
  }
`;

const Secondary = css`
  color: ${props => props.theme.colors.secondary.base};

  &:hover,
  &:focus {
    color: ${props => props.theme.colors.secondary.hover};
    text-decoration: none;
  }
`;

export const PrimaryLink = styled(Link)`
  ${Base}
  ${Primary}
`;

export const SecondaryLink = styled(Link)`
  ${Base}
  ${Secondary}
`;

export const PrimaryLinkExternal = styled.a`
  ${Base}
  ${Primary}
`;

export const SecondaryLinkExternal = styled.a`
  ${Base}
  ${Secondary}
`;

export const HeaderMenuLink = styled(Link)`
  color: ${props => props.theme.colors.typography.dark.base};
  padding-right: ${props => props.theme.spacings.medium};
  font-weight: ${props => props.theme.typography.brandTitle.fontWeight};
  position: relative;
  padding-top: ${props => props.theme.spacings.tiny};
  padding-bottom: ${props => props.theme.spacings.tiny};
  &:hover,
  &:focus {
    color: ${props => props.theme.colors.typography.dark.hover};
    text-decoration: none;
  }

  ${media => media.theme.media.lessThan('downMedium')`
    color: ${props => props.theme.colors.typography.light.base};
    &:hover,
    &:focus {
      color: ${props => props.theme.colors.typography.light.hover};
      text-decoration: none;
    }
  `}
`;
